import urlApi from '../../router/urlApi'
import { Serialize } from '../../services/serializeFormData'
import { LoadFormData } from '../../services/LoadFormData'
import Vue from 'vue'
import Toast from 'vue-toasted'
import router from '../../router'

const toastOptions = {
  theme: 'none',
  position: 'bottom-center',
  className: 'vuestic-toast',
  iconPack: 'fontawesome',
  duration: 5000
}

Vue.use(Toast, toastOptions)
export default {

  store () {
    let self = this

    if(document.getElementById('schema').value === 'Cadastre uma AutoEscola!'){
      self.launchToast('fa-times', 'Cadastre uma AutoEscola!')
      return
    }

    self.disableButtons(true)

    Vue.http.post(urlApi + '/usuarios', Serialize.toObject('form_usuarios')).then((response) => {
      console.log(response)
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarUsuarios()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      console.log(response)
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', response.data.dados)
      }
      self.disableButtons(false)
    })
  },

  update (idUsuario) {
    let self = this
    self.disableButtons(true)
    Vue.http.patch(urlApi + '/usuarios/' + idUsuario, Serialize.toObject('form_usuarios')).then((response) => {
      if (response.status === 200) {
        self.launchToast('fa-check', response.data.mensagem)
        self.pageListarUsuarios()
      } else {
        self.launchToast('fa-check', 'Ops! não foi possivel realizar esta operação!')
      }
      self.disableButtons(false)
    }).catch((response) => {
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-check', response.data.dados)
      }
      self.disableButtons(false)
    })
  },

  atualizaStatus: function (idUsuario, status, callback) {
    let self = this

    Vue.http.patch(urlApi + '/usuarios/' + idUsuario + '/' + status, []).then(function (response) {
      if (response.data.sucesso) {
        self.launchToast('fa-check', 'Status atualizado!')
      } else {
        self.launchToast('fa-check', 'Erro ao tentar atualizar o status!')
      }
      callback()
    })
  },

  getUsuarioById: function (idUsuario, callback) {
    Vue.http.get(urlApi + '/usuarios/' + idUsuario).then(function (response) {
      callback(response)
    })
  },

  getfuncoesUsuarios (callback) {
    Vue.http.get(urlApi + '/usuarios/funcoes').then((response) => {
      callback(response.data)
    })
  },

  getAutoEscolas (callback) {
    Vue.http.get(urlApi + '/cfc').then((response) => {
      callback(response.data)
    })
  },

  getAutoEscolaBySchema ($autoescola, callback) {
    Vue.http.get(urlApi + `/cfc/schema/${$autoescola}`).then((response) => {
      callback(response.data)
    })
  },

  pageListarUsuarios () {
    router.push({ name: 'listagem-usuarios' })
  },

  paginaEdicao (idUsuario) {
    router.push({ name: 'editar-usuario', params: { idUsuario: idUsuario } })
  },

  carregaFormularioDeEdicao (idContato) {
    Vue.http.get(urlApi + '/usuarios/' + idContato).then((response) => {
      LoadFormData.byIdInputs(response.data.dados)
    })
  },

  disableButtons (status) {
    document.getElementById('btn_salvar').disabled = status
    document.getElementById('btn_limpar').disabled = status
  },

  launchToast (icon, msg) {
    Vue.toasted.show(msg, {
      icon: icon,
      position: 'top-right',
      duration: 5000,
      fullWidth: false
    }
    )
  },

  updatePermission (id_funcao_usuario, index, value){
    let self = this

    var request = {
      id_funcao_usuario: id_funcao_usuario,
      index: index,
      value: value
    }

    Vue.http.post(urlApi + '/usuarios/permissoes', request).then((response) => {
      console.log(response)
      self.launchToast('fa-check', 'OK')
    }).catch((response) => {
      console.log(response)
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        self.launchToast('fa-times', 'Ops! não foi possivel realizar esta operação!')
      }
    })
  },

  async getSchemasByUser (idUser ) {
    const response =  await Vue.http.get( `${urlApi}/usuarios/schemas/${idUser}`)

    if (!response.ok) {
      const error =  response.status
      throw new Error ( error )
    }

    let schemas =  await response.json()

    return schemas.dados
  },

  saveSchemasList ( arrayCFC,senha, idUser ) {
    let self = this
    var request = {
      cfcs:  arrayCFC,
      senha : senha
    }

    Vue.http.post( `${urlApi}/usuarios/schemas/cfcs/${idUser}`, request).then((response) => {
      self.launchToast('fa-check', 'OK')
    }).catch((response) => {
      console.log(response)
      if (response.status === 422) {
        Object.keys(response.data.errors).forEach(function (key) {
          self.launchToast('fa-warning', response.data.errors[key][0])
        })
      } else {
        if(response.data.dados === "Senha não correspondem" ) return self.launchToast('fa-times', 'Senhas não correspondem!')
        self.launchToast('fa-times', 'Ops! não foi possivel realizar esta operação!')
      }
    })
  },

  async getUserById (idUser) {

    let response = await Vue.http.get(`${urlApi}/usuarios/${idUser}`)

    if ( !response.ok ) {
      const error =  response.status
      throw new Error( error )
    }

    const dataUser = await response.json(); 

    return dataUser.dados
  }

}
